import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Resolver, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { ControlledField, FieldTypes } from 'src/components/controlled-field';
import { Section } from 'src/components/section';
import { routes } from 'src/constants/routes';
import { getTheme } from 'src/utils/getTheme';

import { styles } from './styles';
import { setPasswordDataDefaultValues, setPasswordDataKeys } from './constants';
import { setPasswordDataSchema } from './setPasswordDataSchema';
import { SetPasswordFormValues } from './types';

export const SetPasswordPage: FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { brand } = getTheme();
    const { control, handleSubmit } = useForm<SetPasswordFormValues>({
        resolver: yupResolver(setPasswordDataSchema) as Resolver<SetPasswordFormValues>,
        defaultValues: setPasswordDataDefaultValues,
        mode: 'onChange',
    });

    const onSubmit = handleSubmit(() => navigate(routes.occupant.details));

    return (
        <Box css={styles.container}>
            <Box css={styles.imageContainer} />

            <Box css={styles.wrapper}>
                <Section header={t('occupant_welcome', { brand })}>
                    <Typography variant="body3">{t('occupant_set_password')}</Typography>
                </Section>
                <ControlledField
                    fieldType={FieldTypes.Password}
                    name={setPasswordDataKeys.password}
                    control={control}
                    label={t('login_dialog_password')}
                    placeholder={t('login_dialog_password')}
                />
                <ControlledField
                    fieldType={FieldTypes.Password}
                    name={setPasswordDataKeys.confirmPassword}
                    control={control}
                    label={t('occupant_repeat_password')}
                    placeholder={t('login_dialog_password')}
                />
                <Button variant="contained" css={styles.cta} onClick={() => onSubmit()}>
                    {t('occupant_set_password_cta')}
                </Button>
            </Box>
        </Box>
    );
};
